import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { RcsMedia } from 'src/app/models/Rcs';
import { environment } from 'src/environments/environment';

/** Galeria de imagens RCS do cliente (`/api/rcs/media`). */
@Injectable({ providedIn: 'root' })
export class RcsMediaService {

  private readonly baseUrl = `${environment.apiUrl}/rcs/media`;

  constructor(private http: HttpClient) {}

  /** A rota pode vir paginada ou como lista: a tela só precisa da lista. */
  list(): Observable<RcsMedia[]> {
    return this.http.get<RcsMedia[] | { data: RcsMedia[] }>(this.baseUrl)
      .pipe(map(response => Array.isArray(response) ? response : (response?.data || [])));
  }

  upload(image: File, title: string, category: string): Observable<RcsMedia> {
    const body = new FormData();
    body.append('image', image);
    body.append('title', title);
    body.append('category', category || '');

    return this.http.post<RcsMedia>(this.baseUrl, body);
  }

  remove(id: string): Observable<void> {
    return this.http.delete<void>(`${this.baseUrl}/${id}`);
  }
}
